module.exports = __webpack_public_path__ + "static/media/AlarmSound.b4581bd3.ogg";